// extracted by mini-css-extract-plugin
module.exports = {"formBox":"MultiQuestionnaireCreateEdit_formBox__1JwGJ"};